export { Size } from '../../../lib/_util/enum';
export var WaitType;
(function (WaitType) {
    WaitType["throttle"] = "throttle";
    WaitType["debounce"] = "debounce";
})(WaitType || (WaitType = {}));
export var Tooltip;
(function (Tooltip) {
    Tooltip["none"] = "none";
    Tooltip["always"] = "always";
    Tooltip["overflow"] = "overflow";
})(Tooltip || (Tooltip = {}));
